var map = {
	"./master-g.png": "I1Hq",
	"./master.png": "zqgW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "F7oz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pay ^\.\/master.*\.png$
// module id = F7oz
// module chunks = 1